import moment from 'moment';

export const calculateExpireTime = (futureTime: string) => {
  const dur = moment.duration(moment(futureTime).diff(moment()));

  const yearsRemain = checkNegativeNumber(dur.years()) || 0;
  const monthsRemain = checkNegativeNumber(dur.months()) || 0;
  const daysRemain = checkNegativeNumber(dur.days()) || 0;
  const hoursRemain = checkNegativeNumber(dur.hours()) || 0;
  const minutesRemain = checkNegativeNumber(dur.minutes()) || 0;
  const secondsRemain = checkNegativeNumber(dur.seconds()) || 0;
  checkNegativeNumber(dur.days());
  return {
    yearsRemain,
    monthsRemain,
    daysRemain,
    hoursRemain,
    minutesRemain,
    secondsRemain,
  };
};

const checkNegativeNumber = (number: number) => {
  const isNegative = Math.sign(number);
  if (isNegative === 1) {
    return number;
  } else {
    return 0;
  }
};
